import { PolicyBilling } from '@/api/models/Contracts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PolicyBillingState {
  policyBilling: PolicyBilling[];
  loading: boolean;
  error: string | null;
  policyId: string | undefined;
}

const initialState: PolicyBillingState = {
  policyBilling: [],
  loading: false,
  error: null,
  policyId: '',
};

const policyBillingSlice = createSlice({
  name: 'policyBilling',
  initialState,
  reducers: {
    fetchPolicyBillingStart(state, action: PayloadAction<{ policyId?: string, clientId?:string }>) {
      state.loading = true;
      state.error = null;
      state.policyId = action.payload.policyId;
    },
    fetchPolicyBillingSuccess: (state, action: PayloadAction<PolicyBilling[]>) => {
      state.policyBilling = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchPolicyBillinFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.policyId = '';
    },
  },
});

export const { fetchPolicyBillingStart, fetchPolicyBillingSuccess, fetchPolicyBillinFailure } =
  policyBillingSlice.actions;

export default policyBillingSlice.reducer;
